import React, { useEffect, useRef, useState } from "react";
import "./reactHeader.css";

// Logo
const Logo = () => (
  <div className="header-title-logo">
    <a href="/">
      <img
        src="/KhorDeveloperLong.png"
        alt="Khor Developer"
        loading="eager"
        decoding="async"
      />
    </a>
  </div>
);

// Nav Links
const NavLinks = ({ isMobile, onClick }) => (
  <div className={`header-nav-links ${isMobile ? "mobile" : ""}`}>
    <div className="header-nav-item" onClick={onClick}>
      <a href="/auth">Download</a>
    </div>
    <div className="header-nav-item" onClick={onClick}>
      <a
        href="https://billing.stripe.com/p/login/bIY3d730f1vmaxafYY"
        target="_blank"
        rel="noopener noreferrer"
      >
        Customer Portal
      </a>
    </div>
  </div>
);

// Book a Demo Button
const ContactButton = ({ isMobile, onClick }) => (
  <div
    className={`header-actions-action ${isMobile ? "mobile" : "desktop"}`}
    onClick={onClick}
  >
    <a className={`${isMobile ? "" : "btn btn--contact"}`} href="/contact?requestType=Demo">
      Contact Us
    </a>
  </div>
);

const ReactHeader = () => {
  const headerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Animate header on scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (headerRef.current) observer.observe(headerRef.current);
    return () => observer.disconnect();
  }, []);

  // Track window resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);

  return (
    <header className={`header ${isVisible ? "visible" : ""}`} ref={headerRef}>
      <div className="header-inner container--fluid">
        <div className="header-display-desktop">
          <div className="header-title">
            <Logo />
          </div>

          <div className="header-actions">
            {/* Desktop links only when not mobile */}
            {!isMobile && <NavLinks isMobile={false} />}
            {!isMobile && <ContactButton isMobile={false} />}

            {/* Hamburger button */}
            {isMobile && (
            <button
                className="mobile-menu-button"
                onClick={toggleMobileMenu}
                aria-label="Menu"
            >
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
            </button>
            )}
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="header-mobile-menu">
            <NavLinks isMobile={true} onClick={() => setMobileMenuOpen(false)} />
            <ContactButton isMobile={true} onClick={() => setMobileMenuOpen(false)} />
          </div>
        )}
      </div>
    </header>
  );
};

export default ReactHeader;

